module.exports = __webpack_public_path__ + "static/media/under16-earn-coin-icon.7f98eabb.png";